import React, { useEffect } from 'react';
import { Layout, Breadcrumb, Empty } from 'antd';
import * as S from './Requests.styled';
import { IsAcceptedSelector, IsOwnerSelector, IsManagerSelector } from 'features/User/UserSlice';
import Meta from 'components/Meta';
import { fetchRequests } from 'features/RequestsList/RequestsListSlice';
import { useAppDispatch } from 'hooks/useStore';
import RequestsList from 'features/RequestsList';
import { useSelector } from 'react-redux';

const { Content } = Layout;

const Requests: React.FC = () => {
	const dispatch = useAppDispatch();

	// Подтвержденность пользователя
	const isAccepted = useSelector(IsAcceptedSelector);
	const isManager = useSelector(IsManagerSelector);
	const isOwner = useSelector(IsOwnerSelector);

	useEffect(() => {
		if (isOwner || (isAccepted && isManager)) dispatch(fetchRequests());
	}, [dispatch, isAccepted, isManager, isOwner]);

	return (
		<>
			<Meta pageName="requests" />
			<Content
				style={{
					padding: '0px 20px 20px 20px',
					display: 'flex',
					flexDirection: 'column',
				}}>
				<Breadcrumb
					items={[{ title: 'realty platform' }, { title: 'requests' }]}
					style={{ margin: '16px 0' }}
				/>
				<S.WorkSpace>
					{isOwner || (isAccepted && isManager) ? (
						<RequestsList />
					) : (
						<S.Empty>
							<Empty
								image={Empty.PRESENTED_IMAGE_SIMPLE}
								description="You do not have the necessary rights to view this section"
							/>
						</S.Empty>
					)}
				</S.WorkSpace>
			</Content>
		</>
	);
};

export default Requests;
